import { render, staticRenderFns } from "./NuevaSena.vue?vue&type=template&id=568e5430"
import script from "./NuevaSena.vue?vue&type=script&lang=js"
export * from "./NuevaSena.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports